import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SearchAndFilters = ({ 
  searchTerm, 
  onSearchChange, 
  filters, 
  onFilterChange, 
  onClearFilters,
  totalResults 
}) => {
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const regionOptions = [
    { value: '', label: 'Todas as regiões' },
    { value: 'north', label: 'Região Norte' },
    { value: 'south', label: 'Região Sul' },
    { value: 'east', label: 'Região Leste' },
    { value: 'west', label: 'Região Oeste' },
    { value: 'central', label: 'Região Central' }
  ];

  const statusOptions = [
    { value: '', label: 'Todos os status' },
    { value: 'active', label: 'Ativo' },
    { value: 'inactive', label: 'Inativo' },
    { value: 'pending', label: 'Pendente' },
    { value: 'suspended', label: 'Suspenso' }
  ];

  const dateRangeOptions = [
    { value: '', label: 'Todo o período' },
    { value: 'today', label: 'Hoje' },
    { value: 'week', label: 'Esta semana' },
    { value: 'month', label: 'Este mês' },
    { value: 'quarter', label: 'Este trimestre' },
    { value: 'year', label: 'Este ano' },
    { value: 'custom', label: 'Período personalizado' }
  ];

  const hasActiveFilters = filters?.region || filters?.status || filters?.dateRange || filters?.startDate || filters?.endDate;

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      {/* Search Bar */}
      <div className="flex flex-col lg:flex-row gap-4 mb-4">
        <div className="flex-1">
          <div className="relative">
            <Icon 
              name="Search" 
              size={20} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <Input
              type="search"
              placeholder="Busque por nome, CPF ou título de eleitor..."
              value={searchTerm}
              onChange={(e) => onSearchChange(e?.target?.value)}
              className="pl-10"
            />
          </div>
        </div>
        <Button
          variant="outline"
          onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
          iconName={showAdvancedFilters ? "ChevronUp" : "ChevronDown"}
          iconPosition="right"
        >
          Filtros avançados
        </Button>
      </div>
      {/* Advanced Filters */}
      {showAdvancedFilters && (
        <div className="border-t border-border pt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <Select
              label="Região"
              options={regionOptions}
              value={filters?.region}
              onChange={(value) => onFilterChange('region', value)}
            />
            
            <Select
              label="Status"
              options={statusOptions}
              value={filters?.status}
              onChange={(value) => onFilterChange('status', value)}
            />
            
            <Select
              label="Período de cadastro"
              options={dateRangeOptions}
              value={filters?.dateRange}
              onChange={(value) => onFilterChange('dateRange', value)}
            />

            <div className="flex items-end">
              <Button
                variant="outline"
                onClick={onClearFilters}
                disabled={!hasActiveFilters}
                iconName="X"
                iconPosition="left"
                className="w-full"
              >
                Limpar filtros
              </Button>
            </div>
          </div>

          {/* Custom Date Range */}
          {filters?.dateRange === 'custom' && (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <Input
                label="Data inicial"
                type="date"
                value={filters?.startDate}
                onChange={(e) => onFilterChange('startDate', e?.target?.value)}
              />
              <Input
                label="Data final"
                type="date"
                value={filters?.endDate}
                onChange={(e) => onFilterChange('endDate', e?.target?.value)}
              />
            </div>
          )}
        </div>
      )}
      {/* Results Count */}
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <span>
          {totalResults === 1 ? '1 membro encontrado' : `${totalResults?.toLocaleString()} membros encontrados`}
        </span>
        {hasActiveFilters && (
          <span className="flex items-center space-x-1">
            <Icon name="Filter" size={14} />
            <span>Filtros aplicados</span>
          </span>
        )}
      </div>
    </div>
  );
};

export default SearchAndFilters;